module.exports = __webpack_public_path__ + "static/media/final_popup_delete_acc3.aa5a1b74.jpg";